import React from 'react';
import 'react-dates/lib/css/_datepicker.css';
import { Button, Input } from 'semantic-ui-react';
import { errorInput } from '../../../components/helpers';
import useRememberCredentials from '../../../components/helpers/useRememberCredentials';
import RememberCredentialsCheckbox from '../../../components/helpers/RememberCredentialsCheckbox';
import { withRouter } from 'react-router-dom';
import { RegistrationForm } from 'src/assets/styles/components/Registration';

const ParentsLogin = (props) => {
  const { inputs, setInputs, leaders, getInfo, parsedQueryString, set_loading, loading } = props;
  const [errorInputs, set_errorInputs] = React.useState({});
  const { rememberCredentials, setRememberCredentials, persistCredentials } =
    useRememberCredentials({ setInputs });

  const verifyForm = () => {
    let mandatoryInputs = ['identification', 'phone'];
    let errorInputs = {};

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs[input] },
      });
    });

    if (inputs['identification'] && inputs['identification'].length <= 5) {
      errorInputs = errorInput({
        errorInputs,
        input: {
          name: 'identification',
          value: inputs['identification'].length >= 5,
        },
      });
    }

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  React.useEffect(() => {
    if (!parsedQueryString.activityName && inputs.kindgroup)
      props.history.push(`?kindgroup=${inputs.kindgroup}`);
  }, [inputs.kindgroup]);

  React.useEffect(() => {
    if (
      parsedQueryString.identification &&
      parsedQueryString.phone &&
      inputs.identification &&
      inputs.phone
    )
      enterReservation({ preventDefault: () => {} });
  }, [inputs.identification]);

  const enterReservation = (e) => {
    e.preventDefault();
    if (verifyForm()) return;
    set_loading(true);

    persistCredentials({
      identification: inputs.identification,
      phone: inputs.phone,
    });

    if (leaders) {
      getInfo();
    }
  };

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setInputs({ ...inputs, [name]: value });
  };

  return (
    <>
      <h1>¡Gracias por preinscribir a tus hijos a generaciones!</h1>
      <RegistrationForm onSubmit={(e) => enterReservation(e)}>
        <label style={{ display: 'block', padding: '20px', fontSize: '35px' }}>
          Escribe tus datos como responsable del niño
        </label>
        {Object.values(errorInputs).includes(true) && (
          <h4 style={{ color: 'red' }}>Por favor verifica los campos en rojo.</h4>
        )}
        <Input
          style={{ width: '45%' }}
          onChange={handleInputs}
          name={'identification'}
          value={inputs.identification}
          type="number"
          placeholder="Identificación"
          id="identification"
          className={`Registration__input Registration__input-${'identification'} ${
            errorInputs['identification'] ? 'error' : ''
          }`}
        />
        <Input
          placeholder="Celular"
          id="phone"
          name={'phone'}
          type="number"
          className={`Registration__input Registration__input-${'phone'} ${
            errorInputs['phone'] ? 'error' : ''
          }`}
          value={inputs.phone}
          onChange={handleInputs}
          style={{ width: '45%', margin: '5px' }}
        />
        <RememberCredentialsCheckbox
          checked={rememberCredentials}
          onChange={setRememberCredentials}
        />

        <Button primary disabled={loading} type="submit">
          Entrar
        </Button>
      </RegistrationForm>
    </>
  );
};

export default withRouter(ParentsLogin);
